import { render, staticRenderFns } from "./DocMasterUploadClient.vue?vue&type=template&id=274e3a32&scoped=true&"
import script from "./DocMasterUploadClient.vue?vue&type=script&lang=js&"
export * from "./DocMasterUploadClient.vue?vue&type=script&lang=js&"
import style0 from "./DocMasterUploadClient.vue?vue&type=style&index=0&id=274e3a32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e3a32",
  null
  
)

export default component.exports